module.exports = __webpack_public_path__ + "img/export.fa9a9e87.svg";